export default {
  0: 'Authing は、あらゆる Web、App、企業向けソフトウェアのためのアイデンティティとアクセス管理プラットフォームを提供し、あらゆる企業や開発者が最初から最後までビジネスの成功を達成できるようにサポートする。',
  1: '会社に代わってアカウントを登録しますか',
  2: '無料でビジネス相談に応じます。',
  3: 'お申し込みにご案内します。',
  4: 'ログインしてホームページにジャンプしています。',
  5: '登録に成功した。ログインページに移動します。',
  快速安全的云身份认证: '高速で安全なアイデンティティ認証',
  公司用户: '企業ユーザー',
  个人用户: '個人ユーザー',
  公司名称姓名: '公司名称姓名',
  公司名称: '会社名',
  姓名: '名前',
  手机号验证码: '携帯電話番号検証コード',
  手机号: '携帯電話番号',
  验证码: '検証コード',
  获取验证码: '検証コードを取得する',
  请秒后重试: ' {0} 秒後にもう一度お試しください',
  免费使用: '無料アクセス',
  请输入验证码: '検証コードを入力してください',
  请输入公司联系人的姓名: '会社の担当者名を入力してください',
  请先输入正确的手机号: '正しい携帯電話番号を入力してください',
};
